export default "__VITE_ASSET__CkwxH3xj__"